export function getVisitors ({ state, commit }) {
  return new Promise((resolve, reject) => {
    axiosInstance.get('/v1/dashboard/visitors')
      .then((response) => {
        commit('setVisitors', response.data)
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export function getOrders ({ state, commit }) {
  return new Promise((resolve, reject) => {
    axiosInstance.get('/v1/dashboard/orders')
      .then((response) => {
        commit('setOrders', response.data)
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export function getOferte ({ state, commit }) {
  return new Promise((resolve, reject) => {
    axiosInstance.get('/v1/dashboard/oferte')
      .then((response) => {
        commit('setOferte', response.data)
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export function getOferteWhatsapp ({ state, commit }) {
  return new Promise((resolve, reject) => {
    axiosInstance.get('/v1/dashboard/oferte_wa')
      .then((response) => {
        commit('setOferteWhatsapp', response.data)
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
}
